import { isSupportedCountry, parsePhoneNumberFromString } from 'libphonenumber-js';

export const getAbbreviatedSurname = (name: string) => {
  const hasAtLeast2Words = /[a-zA-Z]+\s+[a-zA-Z]+/g;
  if (hasAtLeast2Words.test(name)) {
    const [fistName, surName] = name.split(' ');
    // @ts-expect-error fixable: unchecked index access
    const FormattedName = `${fistName} ${surName[0]}.`;
    return FormattedName;
  }
  return name;
};

// PhoneNumberInput never emits for a seeded value, so an untouched legacy number needs this at submit.
export const toE164 = (phone: string, interpretCountry?: string) => {
  const country = (interpretCountry || 'US').toUpperCase();
  const parsed = parsePhoneNumberFromString(
    phone,
    isSupportedCountry(country) ? country : undefined,
  );

  return parsed?.isValid() ? parsed.number : phone;
};
